import { PaletteMode } from "@mui/material";
import { createContext } from "react";

type ContextType = {
    theme: PaletteMode
    setTheme: (data: PaletteMode) => void
};

export const ProjectContext = createContext<ContextType>({
    theme: "light",
    setTheme: (_: PaletteMode) => {},
});